<mat-dialog-content>
  <form [formGroup]="reportCopyForm" class="report-copy-form">
    <div class="report-date-field">
      <valumize-report-date-picker label="New Report Date"
                                   [autoSelectLatestQuarter]="false"
                                   [formControl]="reportCopyForm.controls.reportDate"></valumize-report-date-picker>
      @if (reportCopyForm.controls.reportDate.touched && reportCopyForm.controls.reportDate.hasError('required')) {
        <p class="report-date-field__error">New report date is required</p>
      }
      @if (reportCopyForm.controls.reportDate.hasError('reportDateNotUnique')) {
        <p class="report-date-field__error">A report for this fund and date already exists</p>
      }
    </div>
    <div style="margin-top: 1rem">
      <mat-checkbox formControlName="copyInvestments" color="primary"></mat-checkbox>
      Copy Investments
    </div>
    @if (reportCopyForm.get('copyInvestments')?.value) {
      <div class="table-scroll-wrapper">
        <table mat-table [dataSource]="(fundInvestments$ | async) || []">
          <ng-container matColumnDef="assetId">
            <th mat-header-cell *matHeaderCellDef>Asset ID</th>
            <td mat-cell *matCellDef="let element">{{element.assetId}}</td>
          </ng-container>
          <ng-container matColumnDef="assetName">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">
              @if (getAssetNameAndArchivedById(element.assetId) | async; as assetData) {
                @if (assetData.isArchived) {
                  <mat-icon class="archived-icon">inventory_2</mat-icon>
                }
                {{assetData.name}}
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="ownershipStake">
            <th mat-header-cell *matHeaderCellDef>Ownership Stake</th>
            <td mat-cell *matCellDef="let element">{{element.ownershipStake | traceableFormat}}</td>
          </ng-container>
          <ng-container matColumnDef="investmentDate">
            <th mat-header-cell *matHeaderCellDef>Investment Date</th>
            <td mat-cell *matCellDef="let element">{{element.investmentDate | traceableFormat}}</td>
          </ng-container>
          <ng-container matColumnDef="isRealized">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    color="primary"
                    [checked]="isAllRealizedSelected()"
                    (change)="toggleAllRealized($event.checked)">
                </mat-checkbox>
                Realized
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-checkbox color="primary" [formControl]="getIsRealizedControl(i)"></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="copyGpValuation">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    color="primary"
                    [checked]="isAllCopyGpValuationSelected()"
                    (change)="toggleAllCopyGpValuation($event.checked)">
                </mat-checkbox>
                Copy GP Valuation
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-checkbox color="primary" [formControl]="getCopyGpValuationControl(i)"></mat-checkbox>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="fundInvestmentsColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: fundInvestmentsColumns"></tr>
        </table>
      </div>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button
    color="primary"
    [disabled]="!reportCopyForm.valid"
    (click)="navigateToFundValuationCopyDialog()">
    Next
  </button>
</mat-dialog-actions>
